/**
 * Version utilities for the CMHT frontend
 */

/**
 * Get the current release version
 * Falls back to package.json version if release version is not available
 */
export const getReleaseVersion = (): string => {
    return (
        import.meta.env.VITE_RELEASE_VERSION ||
        import.meta.env.VITE_APP_VERSION ||
        "unknown"
    )
}

/**
 * Get version info for display purposes
 */
export const getVersionInfo = () => {
    const version = getReleaseVersion()
    const buildTime = import.meta.env.VITE_BUILD_TIME || "unknown"

    return {
        version,
        buildTime,
        display: `v${version}`,
        full: `CMHT Frontend v${version} (built: ${buildTime})`,
    }
}

/**
 * Log version info to console
 */
export const logVersionInfo = () => {
    const versionInfo = getVersionInfo()
    console.log(`🚀 ${versionInfo.full}`)

    // Also log to Sentry if available
    if (typeof window !== "undefined" && (window as any).Sentry) {
        ;(window as any).Sentry.setTag("version", versionInfo.version)
        ;(window as any).Sentry.setTag("build_time", versionInfo.buildTime)
    }
}
